import React from 'react'

export const Periode = ({ item }) => {
    return (
        <>
            <p className="mb-2  text-gray-800 text-xs">
                {item?.periode?.jour === 0 && item?.periode?.heure === 0 && item?.periode?.minutes === 0 ? "à l'instant" : item?.periode ? "il y'a" : ""}  {item?.periode?.jour ? item?.periode?.jour + " jours, " : ""} {item?.periode?.heure ? item?.periode?.heure + " heures, " : ""}
                {" "} {item?.periode?.minutes ? item?.periode?.minutes + " minutes" : ""}
            </p>
        </>
    )
}
